import { Fragment, useState } from 'react'

import ReactText from '../../../ReactText'
import { ContentFragment, Elements, RevealCardsProps } from '../../types'

const RevealCardsSmallScreen = (props: RevealCardsProps): JSX.Element => {
  const { contentFragments } = props
  const [openCardIndex, setOpenCardIndex] = useState<number | null>(null)

  const handleCardClick = (index: number) => {
    setOpenCardIndex(index === openCardIndex ? null : index)
  }

  const renderCard = (elements: Elements, id: string, index: number) => {
    const { icon, iconAtltxt, description, title } = elements

    return (
      <div className={`card-container col-md-12`} data-testid={id}>
        <div
          className={`reveal__card ${openCardIndex === index ? 'card-opened' : 'card-closed'}`}
          data-active-card={`active-card-${index}`}
          onClick={() => handleCardClick(index)}
        >
          <div className='reveal__card-content text-md-center'>
            {icon && <img src={icon?.value} alt={iconAtltxt?.value} className='reveal__card-icon' />}
            {title && <ReactText text={title?.value} className='reveal__card-title' />}
          </div>

          <div className='reveal__card-description'>
            {description && <ReactText text={description?.value} className='description' />}
          </div>
          <span className='reveal__card-toggle-sign'></span>
        </div>
      </div>
    )
  }

  return (
    <div className='reveal__cards-grid-small row' data-testid='reveal__cards-grid-small'>
      {contentFragments?.map((item: ContentFragment, index: number) => {
        const elements = item?.elements || {}
        const id = item?.id

        return <Fragment key={id}>{renderCard(elements, id, index)}</Fragment>
      })}
    </div>
  )
}

export default RevealCardsSmallScreen
